"use client";

import { useContext } from "react";

import { abContext } from "../lib";

export const useABContext = () => useContext(abContext);
